import React from 'react';

const SvgIconUtilityOn = props => (
  <svg width={181} height={87} viewBox="0 0 181 87" {...props}>
    <defs>
      <linearGradient
        id="icon-utility-on_svg__a"
        x1="49.995%"
        x2="49.995%"
        y1="-68.516%"
        y2="97.78%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__b" x1="25.22%" x2="65.59%" y1="37.116%" y2="66.376%">
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__c"
        x1="24.555%"
        x2="77.497%"
        y1="-6.78%"
        y2="105.865%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__d"
        x1="50.108%"
        x2="50.448%"
        y1="50.007%"
        y2="50.57%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__e" x1="50%" x2="50.67%" y1="49.485%" y2="50.591%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__f"
        x1="49.988%"
        x2="50.558%"
        y1="49.142%"
        y2="50.086%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__g" x1="34.394%" x2="71.748%" y1="11.8%" y2="94.51%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__h" x1="49.5%" x2="50.13%" y1="49.762%" y2="50.792%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__i"
        x1="46.307%"
        x2="53.047%"
        y1="13.626%"
        y2="91.336%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__j"
        x1="20.272%"
        x2="80.089%"
        y1="10.395%"
        y2="89.963%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__k"
        x1="20.452%"
        x2="80.189%"
        y1="10.813%"
        y2="89.716%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__l"
        x1="39.648%"
        x2="62.229%"
        y1="1.02%"
        y2="100.524%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__m"
        x1="18.127%"
        x2="79.515%"
        y1="25.606%"
        y2="91.997%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__n"
        x1="35.825%"
        x2="64.089%"
        y1="48.074%"
        y2="51.916%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__o" x1="48.34%" x2="50.89%" y1="48.17%" y2="52.59%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__p" x1="42.38%" x2="57.39%" y1="36.71%" y2="62.7%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__q" x1="43.18%" x2="56.12%" y1="39.35%" y2="61.75%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__r" x1="46.88%" x2="52.59%" y1="45.25%" y2="55.13%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__s" x1="49.3%" x2="49.94%" y1="48.89%" y2="49.98%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient id="icon-utility-on_svg__t" x1="48.87%" x2="50.36%" y1="48.3%" y2="50.89%">
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__u"
        x1="17.507%"
        x2="73.371%"
        y1="1.305%"
        y2="93.832%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__v"
        x1="20.471%"
        x2="112.329%"
        y1="17.392%"
        y2="134.207%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__w"
        x1="-.545%"
        x2="79.556%"
        y1="-19.327%"
        y2="82.537%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__x"
        x1="13.985%"
        x2="51.216%"
        y1="25.639%"
        y2="57.748%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__y"
        x1="24.984%"
        x2="75.003%"
        y1="6.678%"
        y2="93.313%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__z"
        x1="24.995%"
        x2="74.985%"
        y1="6.701%"
        y2="93.285%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__A"
        x1="24.993%"
        x2="75.012%"
        y1="6.678%"
        y2="93.313%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__B"
        x1="25.009%"
        x2="74.998%"
        y1="6.701%"
        y2="93.285%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__C"
        x1="18.708%"
        x2="71.34%"
        y1="22.835%"
        y2="81.624%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__D"
        x1="-146.841%"
        x2="71.447%"
        y1="-245.446%"
        y2="76.186%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__E"
        x1="27.501%"
        x2="86.622%"
        y1=".793%"
        y2="124.169%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__F"
        x1="36.707%"
        x2="60.667%"
        y1="3.046%"
        y2="96.796%"
      >
        <stop offset="0%" stopColor="#E4A8C0" />
        <stop offset="100%" stopColor="#A7496E" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__G"
        x1="36.038%"
        x2="64.731%"
        y1="47.308%"
        y2="52.489%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__H"
        x1="35.999%"
        x2="66.124%"
        y1="45.903%"
        y2="54.184%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-utility-on_svg__I"
        x1="50.503%"
        x2="50.503%"
        y1=".007%"
        y2="100.004%"
      >
        <stop offset="0%" stopOpacity={0} />
        <stop offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <path
          fill="url(#icon-utility-on_svg__a)"
          d="M13.003 66.645s-.047 1.41.241 1.785 1.526-.567 6.642 0c5.115.566 22.074 2.044 23.366 2.458 1.293.413 4.54-1.325 4.54-1.325s70.209-2.696 85.4 3.002l1.752 1.616s1.323.52 3.208.367c1.884-.153 26.2-.153 26.2-.153s1.674-.008 3.59.605c0 0 10.13-10.568-1.62-19.52-11.75-8.944-51.817-22.368-100.061-21.434-48.244.935-52.176 10.009-53.258 32.6z"
        />
        <path
          fill="url(#icon-utility-on_svg__b)"
          d="M177.695 55.136s.07-6.442-5.638-10.056c-5.716-3.614-17.419-6.09-22.778-7.298-5.359-1.207-14.805-1.768-17.35-3.614-2.535-1.838-21.296-19.332-25.67-22.805-4.374-3.474-9.167-5.74-15.798-7.08C83.83 2.943 63.805 1.237 46.316.458 28.827-.32 13.17-.25 11.06 1.806 8.942 3.862 5.607 8.348 4.05 23.03 2.49 37.712 2.537 48.89 2.537 48.89s-.582.054-.845.583c-.264.522-1.009 2.586-1.009 3.801 0 1.215.326 6.45.326 6.45S0 60.112 0 61.327s.52 3.762 3.296 4.455c2.769.686 10.237 1.636 10.237 1.636s-.24-4.673 1.947-8.015c2.14-3.256 5.879-5.507 9.656-6.13 3.784-.623 8.197-.444 12.083 1.87 3.785 2.25 7.344 6.41 7.08 15.087 0 0 55.306 1.97 89.919 4.08 0 0 .279-7.336 3.117-11.932 2.839-4.595 7.818-7.905 14.007-7.617 6.197.288 11.812 4.884 13.658 9.066 1.853 4.183 2.202 7.5 2.086 11.162 0 0 7.988.17 9.842-.873 1.853-1.044 1.791-1.861 2.202-3.723.404-1.861 1.737-8.723 0-10.406 0 0 .093-3.668-.217-4.003-.318-.335-.706-.553-1.218-.85z"
        />
        <path
          fill="url(#icon-utility-on_svg__c)"
          d="M172.348 44.582c-1.428-.936-3.237-1.8-5.217-2.582-.893 3.3 2.99 7.174 5.124 9.264C174.39 53.354 178 55 178 55s.07-6.682-5.652-10.418z"
        />
        <path
          fill="url(#icon-utility-on_svg__d)"
          d="M16.976 4.758s.008.008 0 0c.008.008 0 0 0 0z"
          transform="translate(161 50)"
        />
        <path fill="url(#icon-utility-on_svg__e)" d="M16.976 4.68z" transform="translate(161 50)" />
        <path
          fill="url(#icon-utility-on_svg__f)"
          d="M16.048.5v.008c.008-.008 0-.008 0-.008z"
          transform="translate(161 50)"
        />
        <path
          fill="url(#icon-utility-on_svg__g)"
          d="M18.456 9.656s.096-3.68-.224-4.015c-.32-.336-.712-.555-1.248-.852 0 0-3.72-1.601-5.92-3.617-.272-.25-.568-.524-.88-.82l.408 6.07h-4.12L.744 9.289c1.408 1.328 2.504 2.797 3.152 4.219 1.912 4.195 2.272 7.523 2.152 11.195 0 0 8.24.172 10.152-.875 1.912-1.047 1.848-1.867 2.272-3.734.4-1.867 1.776-8.742-.016-10.438z"
          transform="translate(161 50)"
        />
        <path
          fill="url(#icon-utility-on_svg__h)"
          d="M16.976 4.563v-.001z"
          transform="translate(161 50)"
        />
        <path
          fill="url(#icon-utility-on_svg__i)"
          d="M6.196 49.957C6.628 31.76 7 23.839 7 22.616c0-.931-1.89-3.448-2.8-4.616a104.32 104.32 0 0 0-.72 5.563C1.955 38.436 2 49.759 2 49.759c2.375.379 4.196.198 4.196.198z"
        />
        <path
          fill="url(#icon-utility-on_svg__j)"
          d="M2 43.739L6.895 44c.035-1.305.07-2.552.105-3.739L2.14 40c-.052 1.381-.105 2.627-.14 3.739z"
        />
        <path
          fill="url(#icon-utility-on_svg__k)"
          d="M2 39.739L6.885 40c.035-1.314.08-2.56.115-3.739L2.194 36c-.07 1.33-.141 2.577-.194 3.739z"
        />
        <path
          fill="url(#icon-utility-on_svg__l)"
          d="M2 46h-.845c-.085 0-.155.088-.155.197v1.606c0 .109.07.197.155.197H2v-2z"
        />
        <circle cx={167} cy={62} r={1} fill="#470008" />
        <path
          fill="url(#icon-utility-on_svg__m)"
          d="M127.889 36.409c-.195-.767-.772-1.643-1.403-2.464-2.994-3.943-14.68-14.918-19.123-17.515-4.451-2.598-6.641-2.8-13.08-3.732-6.44-.93-9.69-.93-10.486 0-.795.931-.756 2.19-.795 3.16-.039.97.406 11.915 1.622 15.959 1.216 4.044 1.808 5.054 4.537 5.71 2.728.658 21.929 1.229 27.323 1.69 3.368.282 6.689.798 9.105.783 1.832-.016 2.744-1.807 2.3-3.591zm-6.525.853c-.133.43-.265.829-.39 1.197-1.777-.157-3.796-.415-5.83-.58-4.99-.414-22.756-.938-25.282-1.525-2.525-.594-3.071-1.51-4.194-5.178-1.122-3.67-1.543-13.166-1.574-14.05-.04-1.056-.219-2.582.522-3.427.74-.844 4.03-.72 9.986.133 5.956.845 7.983 1.025 12.099 3.38 2.705 1.549 8.957 7.01 13.361 11.273.904 2.096 2.183 5.859 1.302 8.777z"
        />
        <path
          fill="url(#icon-utility-on_svg__n)"
          d="M134.737 74s.046-1.132.263-2.778c0 0-71.771-3.512-90-4.222.07.913.093 1.88.062 2.91 0 0 55.15 1.975 89.675 4.09z"
        />
        <path fill="url(#icon-utility-on_svg__o)" d="M2.6 1.492z" transform="translate(0 47)" />
        <path fill="url(#icon-utility-on_svg__p)" d="M2.6.846z" transform="translate(0 47)" />
        <path
          fill="url(#icon-utility-on_svg__q)"
          d="M2.6 1.485v-.231.23z"
          transform="translate(0 47)"
        />
        <path
          fill="url(#icon-utility-on_svg__r)"
          d="M2.6 1.223v-.1.1z"
          transform="translate(0 47)"
        />
        <path
          fill="url(#icon-utility-on_svg__s)"
          d="M2.6 1.615v-.007.007z"
          transform="translate(0 47)"
        />
        <path
          fill="url(#icon-utility-on_svg__t)"
          d="M2.6 1.585v-.023.023z"
          transform="translate(0 47)"
        />
        <path
          fill="url(#icon-utility-on_svg__u)"
          d="M19.238 8.362l-4.93-5.67-7.454-.869S5.008 2 2.6 1.631c0 0-.577.054-.838.577-.262.515-1 2.554-1 3.754 0 1.2.323 6.369.323 6.369s-1 .384-1 1.584c0 1.2.515 3.716 3.269 4.4 2.746.677 10.184 1.639 10.184 1.639s0-4.577 2.17-7.87a14.179 14.179 0 0 1 3.538-3.692c-.008-.023-.008-.03-.008-.03z"
          transform="translate(0 47)"
        />
        <path
          fill="url(#icon-utility-on_svg__v)"
          d="M90.485 47h-3.631C85.83 47 85 46.216 85 45.25v-3.5c0-.966.83-1.75 1.854-1.75h3.623C92.423 40 94 41.489 94 43.326v.363C94 45.51 92.43 47 90.485 47z"
        />
        <path
          fill="url(#icon-utility-on_svg__w)"
          d="M73.515 47h3.631C78.17 47 79 46.216 79 45.25v-3.5c0-.966-.83-1.75-1.854-1.75h-3.623C71.577 40 70 41.489 70 43.326v.363C70 45.519 71.577 47 73.515 47z"
        />
        <path
          fill="url(#icon-utility-on_svg__x)"
          d="M94 43.778C93.823 41.656 92.237 40 90.297 40h-3.334C85.878 40 85 40.983 85 42.2v1.509c1.124.146 4.68.535 9 .069z"
        />
        <circle cx={150} cy={73} r={14} fill="url(#icon-utility-on_svg__y)" />
        <circle cx={150.5} cy={72.5} r={9.5} fill="url(#icon-utility-on_svg__z)" />
        <circle cx={29} cy={73} r={14} fill="url(#icon-utility-on_svg__A)" />
        <circle cx={29.5} cy={72.5} r={9.5} fill="url(#icon-utility-on_svg__B)" />
        <ellipse
          cx={178.425}
          cy={69.165}
          fill="#470008"
          rx={2.354}
          ry={1.111}
          transform="rotate(-78.428 178.425 69.165)"
        />
        <path
          fill="url(#icon-utility-on_svg__C)"
          d="M121.697 36.811c.898-2.88-.401-6.594-1.307-8.655-4.45-4.208-10.767-9.597-13.5-11.126-4.16-2.324-6.207-2.501-12.225-3.335-6.017-.834-9.35-.965-10.09-.131-.748.833-.567 2.339-.527 3.381.031.873.457 10.246 1.59 13.867 1.135 3.621 1.694 4.524 4.238 5.111 2.552.587 20.503 1.104 25.544 1.506 2.056.17 4.096.417 5.891.571.119-.37.252-.757.386-1.189z"
        />
        <path
          fill="url(#icon-utility-on_svg__D)"
          d="M122.46 36.124c.196.183.346.73.402 1.025.056.294.486 1.168 1.961.73 1.476-.436 2.195-1.374 2.177-2.581-.028-1.208-.486-1.852-1.364-2.034-.887-.183-1.663-.088-2.251-.255-.588-.167-2.158 1.955-.925 3.115z"
        />
        <path
          fill="url(#icon-utility-on_svg__E)"
          d="M124.992 31.28c.037-.39-.014-1.386-1.146-1.836-1.132-.45-3.751-.72-4.223 0-.464.72-1.03 4.736-.196 5.253.827.517 2.757 1.506 3.788 1.266 1.03-.24 1.523-.584 1.625-1.266.102-.69.152-3.417.152-3.417z"
        />
        <path
          fill="url(#icon-utility-on_svg__F)"
          d="M.008 53.07c0 .074-.008.138-.008.203 0 .628.065 2.18.139 3.713.99.23 2.101-2.438 1.815-3.362-.278-.914-1.938-.554-1.946-.554z"
        />
        <circle cx={15} cy={55} r={1} fill="#470008" />
        <path
          fill="url(#icon-utility-on_svg__G)"
          d="M47.9 54.001s81.657 3.733 82.317 3.733c.659 0 1.783.534 1.783 1.145 0 .61.039 1.427-.915 2.694-.954 1.267-1.869 1.427-3.69 1.427-1.823 0-74.154-3.145-75.123-3.183-.961-.038-2.341-.488-3.055-1.312C48.504 57.68 47 56.07 47 55.162c.008-.94.264-1.183.9-1.16z"
        />
        <path
          fill="url(#icon-utility-on_svg__H)"
          d="M42 37.905L9.513 36.003c-.8-.051-1.481.625-1.512 1.496-.024.837.58 1.548 1.355 1.59L41.992 41v-3.095H42z"
        />
        <path
          d="M.807 60.93H.793c-.093-.007-.166-.108-.16-.216C2.16 38.53.113 1.26.093.88.087.772.16.68.253.671.34.664.427.75.433.857c.02.37 2.067 37.673.54 59.888 0 .108-.073.186-.166.186z"
          fill="url(#icon-utility-on_svg__I)"
          opacity={0.5}
          transform="translate(80 7)"
        />
      </g>
      <path d="M0-7h181v94H0z" />
    </g>
  </svg>
);

export default SvgIconUtilityOn;
